// Registers the Chart.js building blocks used across dashboard pages.
// Imported once (from App.js) so individual chart components don't need
// to repeat registration.
import {
    Chart as ChartJS,
    ArcElement, BarElement, CategoryScale, LinearScale,
    Tooltip, Legend, Title,
} from 'chart.js';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

export default ChartJS;
